export default __webpack_public_path__ + "img/datavan-mpc-flexible-control.5a67db90.png";